import React from "react";

const LauncherButtonModule = props => {
  const { label, clickLink, className } = props;
  const btnClickFunc = () => {
    window.open(clickLink, "_blank");
  };
  return (
    <React.Fragment>
      <div className={className + " launcherBtnModule"}>
        <img src="./logo.png" className={"logoImg"}></img>
        <span className={"craftLabel"}>{label}</span>
        <button className={"LaunchButton"} onClick={btnClickFunc}>
          Launch {label}
        </button>
      </div>
    </React.Fragment>
  );
};

export default LauncherButtonModule;
